import { APIClient } from '../../helpers/api_helper';
const AxiosClient = new APIClient()
const getAllMilestoneList =(params) => AxiosClient.get('/milestone', params);
const createMilestone = (payload) => AxiosClient.post('/milestone', payload);
const getMilestoneDetails = (milestone, query) => AxiosClient.get(`/milestone/${milestone}`, { ...query })
const updateMilestone = (milestone, payload) => AxiosClient.put(`/milestone/${milestone}`, { ...payload })
const updateMilestoneStatus = (milestone, payload) => AxiosClient.put(`/milestone/${milestone}/status`, { ...payload })
const getMilestoneBudgetDashboard = (params) => AxiosClient.get('/milestone-budget-dashboard', params);
const removeMilestone = (milestone, payload) => AxiosClient.put(`/milestone/delete/${milestone}`, {...payload})

export {
    getAllMilestoneList,
    createMilestone,
    getMilestoneDetails,
    updateMilestone,
    updateMilestoneStatus,
    getMilestoneBudgetDashboard,
    removeMilestone
}